import React from "react";
import { Col, DatePicker, Row, Select } from "antd";

import "./Filters.scss";

const { Option } = Select;

const Filters = React.memo(({ onSelectChange, filterValue, filterConfigs = [] }) => {
   return (
      <Row gutter={[12, 12]} className="filters">
         {filterConfigs.map((filterConfig) => {
            const colSpan = filterConfigs.length <= 2 ? 12 : 8;
            return (
               <Col key={filterConfig.key} xs={24} sm={12} md={12} lg={12} xl={colSpan}>
                  <label className="filters--label-text">{filterConfig.label}</label>

                  {filterConfig.type === "calendar" ? (
                     <DatePicker
                        placeholder={filterConfig.placeholder || filterConfig.label}
                        style={{ width: "100%" }}
                        onChange={(date) => onSelectChange(date, filterConfig.key)}
                        value={filterValue[filterConfig.key] || null}
                     />
                  ) : (
                     <Select
                        mode={filterConfig.multiple ? "multiple" : undefined}
                        allowClear
                        showSearch
                        placeholder={filterConfig.placeholder || filterConfig.label}
                        optionFilterProp="children"
                        onChange={(value) => onSelectChange(value, filterConfig.key)}
                        filterOption={(input, option) =>
                           (option?.children ?? "").toLowerCase().startsWith(input.toLowerCase())
                        }
                        value={
                           filterConfig.multiple
                              ? filterValue[filterConfig.key] || []
                              : filterValue[filterConfig.key]
                        }
                        style={{ width: "100%" }}
                     >
                        {filterConfig.options?.map((option) => (
                           <Option key={option.value} value={option.value}>
                              {option.label}
                           </Option>
                        ))}
                     </Select>
                  )}
               </Col>
            );
         })}
      </Row>
   );
});

export default Filters;
